import Component from './Events.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);